// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfw_a bhc_vr bhc_ea bhc_a","MenuItem__Btn":"bfw_b bhc_z"};